import { render, staticRenderFns } from "./BasePDFRenderExamReview.vue?vue&type=template&id=6820639b&scoped=true&"
import script from "./BasePDFRenderExamReview.vue?vue&type=script&lang=js&"
export * from "./BasePDFRenderExamReview.vue?vue&type=script&lang=js&"
import style0 from "./BasePDFRenderExamReview.vue?vue&type=style&index=0&id=6820639b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6820639b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6820639b')) {
      api.createRecord('6820639b', component.options)
    } else {
      api.reload('6820639b', component.options)
    }
    module.hot.accept("./BasePDFRenderExamReview.vue?vue&type=template&id=6820639b&scoped=true&", function () {
      api.rerender('6820639b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BasePDFRenderExamReview.vue"
export default component.exports